import http from '@/http'

export default class Services 
{
  constructor() {
    this._http = http
  }
}
